import { pathURL } from '@/components/constants/urls';
import { usePropertyDetailContext, useUserLanguage } from '@/customHooks';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Button } from '../atoms';
import { Col, Row } from 'react-grid-system';
import textsData from '@/textData/PropertyDetailTexts.json'
import { capitalizeFirstLetter } from '@/helpers';
import { advancedNormalizeDate } from '@/helpers/normalizeDate';
import { useMemo } from 'react';
import { ContractStatusPill } from '../atoms/ContractStatusPill';

const StyledGridTable = styled.div`
  padding-top: ${({ theme }) => theme.spacing.lg} ;
  padding-bottom: ${({ theme }) => theme.spacing.lg} ;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  row-gap: 10px;
`;

const StyledGridHeader = styled.div`
  display: contents;
  & > div {
    font-weight: bold;
    text-align: left;
    padding: 15px;
    border-top: 1px solid grey;
    border-bottom: 1px solid gray;
  }
`;

const StyledGridRow = styled.div`
  display: contents;
  
  & > div {
    padding: 15px;
    background-color: ${({ theme }) => theme.colors.background2};
    font-size: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    align-self: stretch;
    place-content: center;
  }
`;

const URL_TO_NAVIGATE_FOR_CREATING = `/${pathURL.USER}/${pathURL.CONTRACT}/${pathURL.CREATE}`
const URL_TO_NAVIGATE_FOR_DETAILS = `/${pathURL.USER}/${pathURL.CONTRACT}/${pathURL.DETAIL}`

export const PropertyDetailContractsList = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.contractsList : textsData.en.contractsList

  const navigate = useNavigate()
  
  const { property } = usePropertyDetailContext()
  const contracts = useMemo(() =>
    property?.unities?.flatMap(unity => unity.contracts) ?? [],
  [property]);

  const onDeatilsClickHandle = (id: string) => {
    navigate(URL_TO_NAVIGATE_FOR_DETAILS, { state: { id } })
  }
  
  if (contracts.length === 0) {
    return (
      <p><b>{texts.noData}</b></p>
    )
  }

  return (
    <>
      <Row justify="end" align="center">
        <Col xs='content' style={{ marginTop: '1rem' }}>
          <Button
            onClick={() => navigate(URL_TO_NAVIGATE_FOR_CREATING)}
          >
            + Add Contract
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <StyledGridTable>
            <StyledGridHeader>
              <div>{texts.tableHeader.column1}</div>
              <div>{texts.tableHeader.column2}</div>
              <div>{texts.tableHeader.column3}</div>
              <div>{texts.tableHeader.column4}</div>
              <div>{texts.tableHeader.column5}</div>
              <div></div>
            </StyledGridHeader>

            {contracts.map((data) => (
              <StyledGridRow key={data.id}>
                <div>{data.tenant ? `${capitalizeFirstLetter(data.tenant.firstName)} ${capitalizeFirstLetter(data.tenant.lastName)}` : 'N/A'}</div>
                <div>{advancedNormalizeDate(userLanguage, data.createdAt)}</div>
                <div>{advancedNormalizeDate(userLanguage, data.finishDate)}</div>
                <div>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(0)}</div>
                <div><ContractStatusPill status={data.statusOption} /></div>
                <div>
                  <Button
                    secondary
                    upperCased
                    onClick={() => onDeatilsClickHandle(data.id)}
                  >
                    {texts.rowButton}
                  </Button>
                </div>
              </StyledGridRow>
            ))}
          </StyledGridTable>
        </Col>
      </Row>
    </>
  );

}